import { Component, Inject, Input } from '@angular/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { NgIf } from '@angular/common';
import { LIBRARY_CONFIG } from '../../shared';
import * as i0 from "@angular/core";
import * as i1 from "angular-svg-icon";
const _c0 = [[["", "prefix", ""]], [["", "suffix", ""]]];
const _c1 = ["[prefix]", "[suffix]"];
const _c2 = a0 => ({
  stroke: a0
});
const _c3 = a0 => ({
  fill: a0
});
const _c4 = (a0, a1) => ({
  path: a0,
  rect: a1
});
function IconV3Component_svg_icon_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "svg-icon", 2);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r0.getStyle());
    i0.ɵɵpropertyInterpolate("src", ctx_r0.path);
    i0.ɵɵproperty("svgStyle", i0.ɵɵpureFunction2(9, _c4, i0.ɵɵpureFunction1(5, _c2, ctx_r0.color), i0.ɵɵpureFunction1(7, _c3, ctx_r0.containerColor)))("svgAriaLabel", ctx_r0.file);
  }
}
const IconSizes = [16, 24, 32, 48, 175];
export class IconV3Component {
  /**
   * pure filename without the .svg suffix
   * the file must be located in libs\gea-digital-ui-lib\assets\icons-v3
   */
  file = '';
  fileSize;
  /**
   * the colors selection is limited by design
   */
  color = 'blue';
  /**
   * the color, that should appear when hovering
   * the colors selection is limited by design
   */
  hoverColor = 'blue';
  /**
   * the color of the icon container,
   * the colors selection is limited by design
   */
  containerColor;
  /**
   * usually all icons use stroke for coloring - in some rare cases the icons use 'fill'.
   */
  colorProp = 'stroke';
  isFileIcon = false;
  clickable = false;
  /**
   * an alternative base path for the icon location
   */
  baseUrl;
  set appKey(value) {
    if (value) {
      this.appBasePath = this.basePath.replace('core/portal', value.replace('_', '/'));
    }
  }
  appBasePath;
  fileIconFolder = 'file-icons';
  path = '';
  basePath;
  constructor(libConfig) {
    this.basePath = libConfig.iconStorageURL ?? '';
    if (!this.basePath) console.error('please provide a valid iconStorageURL in your libConfig!');
  }
  ngOnInit() {
    this.setIconPath();
  }
  ngOnChanges(changes) {
    if (changes['file'] || changes['fileSize'] || changes['isFileIcon'] || changes['appKey']) {
      this.setIconPath();
    }
  }
  setIconPath() {
    if (this.appBasePath) {
      this.basePath = this.appBasePath;
    }
    if (this.isFileIcon && !this.baseUrl) this.path = this.basePath + this.fileIconFolder + '/' + (this.fileSize ? this.fileSize + 'px_' : '') + this.file + '.svg';else {
      const subFolderPath = this.file.substring(0, this.file.lastIndexOf('/') + 1);
      const fileName = this.file.substring(this.file.lastIndexOf('/') + 1);
      this.path = (this.baseUrl ?? this.basePath) + subFolderPath + (this.fileSize ? this.fileSize + 'px_' : '') + fileName + '.svg';
    }
  }
  inferSize(file) {
    const prefixString = /(\d+)px/i.exec(file)?.pop() || '0';
    const prefix = parseInt(prefixString);
    if (prefix && IconSizes.includes(prefix)) {
      return prefix;
    } else {
      return null;
    }
  }
  hasNoFrame(file) {
    return /_nofr_/.test(file);
  }
  getStyle() {
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    const size = `${this.inferSize(this.file)}`;
    const classes = ['icon-v3', `icon-v3-${this.colorProp}-${this.color}`, `icon-v3-size-${this.fileSize || size}`, `icon-v3-hover-${this.colorProp}-${this.hoverColor || this.color}`, `icon-v3-${this.clickable && 'clickable'}`];
    if (this.containerColor) {
      classes.push(`icon-v3-container-fill-${this.containerColor}`);
    }
    if (this.hasNoFrame(this.file)) {
      classes.push('icon-v3-noframe');
    }
    return classes.join(' ');
  }
  static ɵfac = function IconV3Component_Factory(t) {
    return new (t || IconV3Component)(i0.ɵɵdirectiveInject(LIBRARY_CONFIG));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: IconV3Component,
    selectors: [["geaui-icon-v3"]],
    inputs: {
      file: "file",
      fileSize: "fileSize",
      color: "color",
      hoverColor: "hoverColor",
      containerColor: "containerColor",
      colorProp: "colorProp",
      isFileIcon: "isFileIcon",
      clickable: "clickable",
      baseUrl: "baseUrl",
      appKey: "appKey"
    },
    standalone: true,
    features: [i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
    ngContentSelectors: _c1,
    decls: 4,
    vars: 1,
    consts: [[1, "nowrap"], [3, "svgStyle", "svgAriaLabel", "class", "src", 4, "ngIf"], [3, "svgStyle", "svgAriaLabel", "src"]],
    template: function IconV3Component_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef(_c0);
        i0.ɵɵelementStart(0, "span", 0);
        i0.ɵɵprojection(1);
        i0.ɵɵtemplate(2, IconV3Component_svg_icon_2_Template, 1, 12, "svg-icon", 1);
        i0.ɵɵprojection(3, 1);
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.file);
      }
    },
    dependencies: [AngularSvgIconModule, i1.SvgIconComponent, NgIf],
    styles: [".icon-v3[_ngcontent-%COMP%]{display:flex;align-items:center}.icon-v3-stroke-white[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{stroke:var(--geaui-white)}.icon-v3-container-fill-white[_ngcontent-%COMP%]   rect[_ngcontent-%COMP%]{fill:var(--geaui-white)}.icon-v3-stroke-grey[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{stroke:var(--geaui-grey-01)}.icon-v3-container-fill-grey[_ngcontent-%COMP%]   rect[_ngcontent-%COMP%]{fill:var(--geaui-grey-01)}.icon-v3-stroke-light-grey[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{stroke:var(--geaui-disabled-bg)}.icon-v3-container-fill-light-grey[_ngcontent-%COMP%]   rect[_ngcontent-%COMP%]{fill:var(--geaui-disabled-bg)}.icon-v3-stroke-blue[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{stroke:var(--geaui-vibrant-blue)}.icon-v3-container-fill-blue[_ngcontent-%COMP%]   rect[_ngcontent-%COMP%]{fill:var(--geaui-vibrant-blue)}.icon-v3-stroke-dark-blue[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{stroke:var(--geaui-primary)}.icon-v3-stroke-dark-blue[_ngcontent-%COMP%]   circle[_ngcontent-%COMP%]{stroke:var(--geaui-primary)}.icon-v3-container-fill-dark-blue[_ngcontent-%COMP%]   rect[_ngcontent-%COMP%]{fill:var(--geaui-primary)}.icon-v3-stroke-active-blue[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{stroke:var(--geaui-active-blue-120)}.icon-v3-stroke-active-blue[_ngcontent-%COMP%]   circle[_ngcontent-%COMP%]{stroke:var(--geaui-active-blue-120)}.icon-v3-container-active-blue[_ngcontent-%COMP%]   rect[_ngcontent-%COMP%]{fill:var(--geaui-active-blue-120)}.icon-v3-stroke-vibrant-blue[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{stroke:var(--geaui-vibrant-blue-120)}.icon-v3-stroke-vibrant-blue[_ngcontent-%COMP%]   circle[_ngcontent-%COMP%]{stroke:var(--geaui-vibrant-blue-120)}.icon-v3-stroke-vibrant-blue[_ngcontent-%COMP%]   rect[_ngcontent-%COMP%]{fill:var(--geaui-vibrant-blue-120)}.icon-v3-stroke-focus[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{stroke:var(--geaui-focussed)}.icon-v3-container-fill-focus[_ngcontent-%COMP%]   rect[_ngcontent-%COMP%]{fill:var(--geaui-focussed)}.icon-v3-stroke-cancel-red[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{stroke:var(--geaui-tertiary-red-60)}.icon-v3-container-fill-cancel-red[_ngcontent-%COMP%]   rect[_ngcontent-%COMP%]{fill:var(--geaui-tertiary-red-60)}.icon-v3-stroke-tertiary-red[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{stroke:var(--geaui-tertiary-red-80)}.icon-v3-stroke-tertiary-red[_ngcontent-%COMP%]   circle[_ngcontent-%COMP%]{stroke:var(--geaui-tertiary-red-80)}.icon-v3-container-fill-tertiary-red[_ngcontent-%COMP%]   rect[_ngcontent-%COMP%]{fill:var(--geaui-tertiary-red-80)}.icon-v3-stroke-orange[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{stroke:var(--geaui-radiant-orange)}.icon-v3-container-fill-orange[_ngcontent-%COMP%]   rect[_ngcontent-%COMP%]{fill:var(--geaui-radiant-orange)}.icon-v3-stroke-radiant-orange[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{stroke:var(--geaui-radiant-orange-120)}.icon-v3-stroke-radiant-orange[_ngcontent-%COMP%]   circle[_ngcontent-%COMP%]{stroke:var(--geaui-radiant-orange-120)}.icon-v3-container-fill-radiant-orange[_ngcontent-%COMP%]   rect[_ngcontent-%COMP%]{fill:var(--geaui-radiant-orange-120)}.icon-v3-stroke-dark-orange[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{stroke:var(--geaui-dark-orange)}.icon-v3-stroke-dark-orange[_ngcontent-%COMP%]   circle[_ngcontent-%COMP%]{stroke:var(--geaui-dark-orange)}.icon-v3-container-fill-dark-orange[_ngcontent-%COMP%]   rect[_ngcontent-%COMP%]{fill:var(--geaui-dark-orange)}.icon-v3-stroke-green[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{stroke:var(--geaui-tertiary-green-80)}.icon-v3-container-fill-green[_ngcontent-%COMP%]   rect[_ngcontent-%COMP%]{fill:var(--geaui-tertiary-green-80)}.icon-v3-stroke-black[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{stroke:var(--geaui-primary-black)}.icon-v3-container-fill-black[_ngcontent-%COMP%]   rect[_ngcontent-%COMP%]{fill:var(--geaui-primary-black)}.icon-v3-stroke-black[_ngcontent-%COMP%]   circle[_ngcontent-%COMP%]{stroke:var(--geaui-primary-black)}.icon-v3-fill-white[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--geaui-white)}.icon-v3-fill-grey[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--geaui-disabled-text)}.icon-v3-fill-light-grey[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--geaui-disabled-bg)}.icon-v3-fill-blue[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--geaui-primary)}.icon-v3-fill-focus[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--geaui-focussed)}.icon-v3-fill-cancel-red[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{stroke:var(--geaui-tertiary-red-60)}.icon-v3-fill-black[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--geaui-primary-black)}.icon-v3-fill-dark-blue[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--geaui-primary)}.icon-v3-fill-black[_ngcontent-%COMP%]   circle[_ngcontent-%COMP%]{fill:var(--geaui-primary-black)}.icon-v3-fill-dark-blue[_ngcontent-%COMP%]   circle[_ngcontent-%COMP%]{fill:var(--geaui-primary)}.icon-v3-both-black[_ngcontent-%COMP%]   circle[_ngcontent-%COMP%]{fill:var(--geaui-primary-black);stroke:var(--geaui-primary-black)}.icon-v3-both-dark-blue[_ngcontent-%COMP%]   circle[_ngcontent-%COMP%]{fill:var(--geaui-primary);stroke:var(--geaui-primary)}.icon-v3-both-white[_ngcontent-%COMP%]   path[_ngcontent-%COMP%]{fill:var(--geaui-white);stroke:var(--geaui-white)}.icon-v3-size-16[_ngcontent-%COMP%]{width:16px;height:16px}.icon-v3-size-24[_ngcontent-%COMP%]{width:24px;height:24px}.icon-v3-size-32[_ngcontent-%COMP%]{width:32px;height:32px}.icon-v3-size-48[_ngcontent-%COMP%]{width:48px;height:48px}.icon-v3-size-175[_ngcontent-%COMP%]{width:175px;height:175px}.nowrap[_ngcontent-%COMP%]{display:flex;align-items:center}.icon-v3-clickable[_ngcontent-%COMP%]{cursor:pointer;border-radius:4px;background-clip:content-box}.icon-v3-clickable[_ngcontent-%COMP%]:hover{background-color:var(--geaui-secondary-hover);box-shadow:0 0 0 8px var(--geaui-secondary-hover)}.icon-v3-clickable[_ngcontent-%COMP%]:active{background-color:var(--geaui-secondary-pressed);box-shadow:0 0 0 8px var(--geaui-secondary-pressed)}.icon-v3-clickable[_ngcontent-%COMP%]:focus{background-color:var(--geaui-pure-white);box-shadow:0 0 0 7px var(--geaui-pure-white),0 0 0 8px var(--geaui-black)}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(IconV3Component, [{
    type: Component,
    args: [{
      standalone: true,
      selector: 'geaui-icon-v3',
      imports: [AngularSvgIconModule, NgIf],
      template: "<span class=\"nowrap\"\n  ><ng-content select=\"[prefix]\"></ng-content>\n  <svg-icon\n    *ngIf=\"file\"\n    [svgStyle]=\"{ path: { stroke: color }, rect: { fill: containerColor } }\"\n    [svgAriaLabel]=\"file\"\n    [class]=\"getStyle()\"\n    src=\"{{ path }}\">\n  </svg-icon>\n  <ng-content select=\"[suffix]\"></ng-content>\n</span>\n",
      styles: [".icon-v3{display:flex;align-items:center}.icon-v3-stroke-white path{stroke:var(--geaui-white)}.icon-v3-container-fill-white rect{fill:var(--geaui-white)}.icon-v3-stroke-grey path{stroke:var(--geaui-grey-01)}.icon-v3-container-fill-grey rect{fill:var(--geaui-grey-01)}.icon-v3-stroke-light-grey path{stroke:var(--geaui-disabled-bg)}.icon-v3-container-fill-light-grey rect{fill:var(--geaui-disabled-bg)}.icon-v3-stroke-blue path{stroke:var(--geaui-vibrant-blue)}.icon-v3-container-fill-blue rect{fill:var(--geaui-vibrant-blue)}.icon-v3-stroke-dark-blue path{stroke:var(--geaui-primary)}.icon-v3-stroke-dark-blue circle{stroke:var(--geaui-primary)}.icon-v3-container-fill-dark-blue rect{fill:var(--geaui-primary)}.icon-v3-stroke-active-blue path{stroke:var(--geaui-active-blue-120)}.icon-v3-stroke-active-blue circle{stroke:var(--geaui-active-blue-120)}.icon-v3-container-active-blue rect{fill:var(--geaui-active-blue-120)}.icon-v3-stroke-vibrant-blue path{stroke:var(--geaui-vibrant-blue-120)}.icon-v3-stroke-vibrant-blue circle{stroke:var(--geaui-vibrant-blue-120)}.icon-v3-stroke-vibrant-blue rect{fill:var(--geaui-vibrant-blue-120)}.icon-v3-stroke-focus path{stroke:var(--geaui-focussed)}.icon-v3-container-fill-focus rect{fill:var(--geaui-focussed)}.icon-v3-stroke-cancel-red path{stroke:var(--geaui-tertiary-red-60)}.icon-v3-container-fill-cancel-red rect{fill:var(--geaui-tertiary-red-60)}.icon-v3-stroke-tertiary-red path{stroke:var(--geaui-tertiary-red-80)}.icon-v3-stroke-tertiary-red circle{stroke:var(--geaui-tertiary-red-80)}.icon-v3-container-fill-tertiary-red rect{fill:var(--geaui-tertiary-red-80)}.icon-v3-stroke-orange path{stroke:var(--geaui-radiant-orange)}.icon-v3-container-fill-orange rect{fill:var(--geaui-radiant-orange)}.icon-v3-stroke-radiant-orange path{stroke:var(--geaui-radiant-orange-120)}.icon-v3-stroke-radiant-orange circle{stroke:var(--geaui-radiant-orange-120)}.icon-v3-container-fill-radiant-orange rect{fill:var(--geaui-radiant-orange-120)}.icon-v3-stroke-dark-orange path{stroke:var(--geaui-dark-orange)}.icon-v3-stroke-dark-orange circle{stroke:var(--geaui-dark-orange)}.icon-v3-container-fill-dark-orange rect{fill:var(--geaui-dark-orange)}.icon-v3-stroke-green path{stroke:var(--geaui-tertiary-green-80)}.icon-v3-container-fill-green rect{fill:var(--geaui-tertiary-green-80)}.icon-v3-stroke-black path{stroke:var(--geaui-primary-black)}.icon-v3-container-fill-black rect{fill:var(--geaui-primary-black)}.icon-v3-stroke-black circle{stroke:var(--geaui-primary-black)}.icon-v3-fill-white path{fill:var(--geaui-white)}.icon-v3-fill-grey path{fill:var(--geaui-disabled-text)}.icon-v3-fill-light-grey path{fill:var(--geaui-disabled-bg)}.icon-v3-fill-blue path{fill:var(--geaui-primary)}.icon-v3-fill-focus path{fill:var(--geaui-focussed)}.icon-v3-fill-cancel-red path{stroke:var(--geaui-tertiary-red-60)}.icon-v3-fill-black path{fill:var(--geaui-primary-black)}.icon-v3-fill-dark-blue path{fill:var(--geaui-primary)}.icon-v3-fill-black circle{fill:var(--geaui-primary-black)}.icon-v3-fill-dark-blue circle{fill:var(--geaui-primary)}.icon-v3-both-black circle{fill:var(--geaui-primary-black);stroke:var(--geaui-primary-black)}.icon-v3-both-dark-blue circle{fill:var(--geaui-primary);stroke:var(--geaui-primary)}.icon-v3-both-white path{fill:var(--geaui-white);stroke:var(--geaui-white)}.icon-v3-size-16{width:16px;height:16px}.icon-v3-size-24{width:24px;height:24px}.icon-v3-size-32{width:32px;height:32px}.icon-v3-size-48{width:48px;height:48px}.icon-v3-size-175{width:175px;height:175px}.nowrap{display:flex;align-items:center}.icon-v3-clickable{cursor:pointer;border-radius:4px;background-clip:content-box}.icon-v3-clickable:hover{background-color:var(--geaui-secondary-hover);box-shadow:0 0 0 8px var(--geaui-secondary-hover)}.icon-v3-clickable:active{background-color:var(--geaui-secondary-pressed);box-shadow:0 0 0 8px var(--geaui-secondary-pressed)}.icon-v3-clickable:focus{background-color:var(--geaui-pure-white);box-shadow:0 0 0 7px var(--geaui-pure-white),0 0 0 8px var(--geaui-black)}\n"]
    }]
  }], () => [{
    type: undefined,
    decorators: [{
      type: Inject,
      args: [LIBRARY_CONFIG]
    }]
  }], {
    file: [{
      type: Input
    }],
    fileSize: [{
      type: Input
    }],
    color: [{
      type: Input
    }],
    hoverColor: [{
      type: Input
    }],
    containerColor: [{
      type: Input
    }],
    colorProp: [{
      type: Input
    }],
    isFileIcon: [{
      type: Input
    }],
    clickable: [{
      type: Input
    }],
    baseUrl: [{
      type: Input
    }],
    appKey: [{
      type: Input
    }]
  });
})();
